// extracted by mini-css-extract-plugin
module.exports = {"container":"AssetTypeDropdownSelector_container__mur0q","title":"AssetTypeDropdownSelector_title__ya4bA"};